// extracted by mini-css-extract-plugin
export default {"index":"clients_index__x0jeN","action-filter-buttons":"clients_action-filter-buttons__Ps7J9","separator":"clients_separator__mw3+9"};